import type { ComponentProps, HTMLAttributes, ReactNode } from "react";

import { cn } from "@alaffia-technology-solutions/tailwind-utils";

interface ListRootProps extends HTMLAttributes<HTMLDivElement> {
  header?: ReactNode;
}

const ListRoot = ({ children, className, header, ...props }: ListRootProps) => (
  <nav
    className={cn("af-flex af-flex-col af-overflow-hidden", className)}
    {...props}
  >
    {header}
    <ul className="af-m-0 af-flex af-list-none af-flex-col af-gap-0 af-overflow-y-auto af-border-t af-border-border af-px-2 af-py-2">
      {children}
    </ul>
  </nav>
);

type ListIconProps = HTMLAttributes<HTMLSpanElement>;

const ListIcon = ({ className, ...props }: ListIconProps) => (
  <span
    className={cn(
      "af-inline-flex af-h-4 af-w-4 af-min-w-4 [&>svg]:af-h-4 [&>svg]:af-w-auto",
      className,
    )}
    {...props}
  />
);

interface ListItemProps extends ComponentProps<"button"> {
  isActive: boolean;
}
const ListItem = ({
  className,
  isActive,
  children,
  ...props
}: ListItemProps) => (
  <li className="af-list-none">
    <button
      className={cn(
        "af-flex af-w-full af-items-center af-gap-2 af-rounded-lg af-p-1.5 af-text-left af-text-xs af-font-normal af-text-foreground/70 af-transition-colors focus-visible:af-outline-none focus-visible:af-ring-2 focus-visible:af-ring-interface-ring hover:enabled:af-bg-accent disabled:af-cursor-not-allowed",
        {
          "af-bg-secondary/40 af-font-medium af-text-foreground": isActive,
        },
        className,
      )}
      {...props}
    >
      {children}
    </button>
  </li>
);

export const List = Object.assign(ListRoot, {
  Icon: ListIcon,
  Item: ListItem,
});
